import CategoryPage from "@/pages/category/components/CategoryPage";
import { getArticlesByCategory } from "@/mocks/articles";

export default function BanbenGengxin() {
  return (
    <CategoryPage
      categorySlug="banben-gengxin"
      metaTitle="版本更新 - 版本更新漫画与活动内容速递 | 可游漫画网"
      metaDesc="可游漫画网版本更新栏目，跟进游戏大版本更新漫画与活动内容，版本更新漫画解析、玩法改动与活动福利速递抢先掌握。"
      heading="版本更新"
      kicker="更新速递"
      articles={getArticlesByCategory("banben-gengxin")}
    />
  );
}